import axios, {AxiosRequestConfig, Method} from 'axios';
import {CreateParams, DeleteManyParams, DeleteParams, GetListParams, GetOneParams, GetManyParams, UpdateParams} from 'ra-core';
import {PathCreator} from './RequestPath';

const getToken = () => {
   const token = localStorage.getItem('token');
   return token;
};

const getPathFromUrl = (url) => {
   return url.split(/[?#]/)[0];
}

const getExtensionFile = (filename) => {
   return filename.split('.').pop();
}

//  'Access-Control-Expose-Headers': 'Content-Range',
export class Api {
   private static headers_login = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
   };

   private static get headers() {
      return {
         Accept: 'application/json',
         'Content-Type': 'application/json',
         Authorization: 'Bearer ' + getToken()
      };
   }

   private static config = (method: Method, headers: any): AxiosRequestConfig => {
      return {baseURL: process.env.REACT_APP_API_URL, method: method, headers: headers};
   };

   static GetUsers(id: number) {
      const headers = Api.headers;

      const config: AxiosRequestConfig = {
         baseURL: process.env.REACT_APP_API_URL,
         headers: headers,
         method: 'POST',
         url: '',
         data: JSON.stringify({
            id: id
         })
      };
      return axios(config);
   }

   static Login(password: string, email: string) {
      const conf = Api.config('POST', Api.headers_login);
      conf.url = PathCreator.LOGIN_PATH;
      conf.data = JSON.stringify({password: password, email: email});

      return axios(conf);
   }

   static CreateMultipleList(path: string, params: CreateParams) {
      const conf = Api.config('POST', Api.headers);
      conf.url = path;
      conf.data = JSON.stringify({...params.data, type: 'multiple'});

      return axios(conf);
   }

   static CreateRecommendList(path: string, params: CreateParams) {
      const conf = Api.config('POST', Api.headers);
      conf.url = path;
      conf.data = JSON.stringify({...params.data, type: 'recommend'});

      return axios(conf);
   }

   static CreateCategoryList(path: string, params: CreateParams) {
      const conf = Api.config('POST', Api.headers);
      conf.url = path;
      conf.data = JSON.stringify({...params.data, type: 'category'});

      return axios(conf);
   }

   static GetList(path: string, params: GetListParams) {
      const conf = Api.config('GET', Api.headers);
      conf.url = PathCreator.GetAllItems(path, params);
      return axios(conf);
   }

   static GetAdminVersion(path): any {
      const conf = Api.config('GET', Api.headers);
      conf.url = path;
      return axios(conf)
   }
   static GetCampaign(path) {
      const conf = Api.config('GET', Api.headers);
      conf.url = path;

      return axios(conf)
   }
   static UploadCampaignImage(path:string,params:UpdateParams) {
      const conf = Api.config('POST', Api.headers);
      conf.url = path;
      return axios(conf)
   }

   static GetCampaignOne(path: string) {
      const conf = Api.config('GET', Api.headers);
      conf.url = path;
      return axios(conf);
   }


   static ExportList(path: string, params: GetListParams, ids: GetManyParams) {
      const conf = Api.config('GET', Api.headers);
      conf.url = PathCreator.GetExportSelectedItems(path, params, ids);
      return axios(conf);
   }

   static GetStylePostList(path:string, params:GetListParams){
      const conf = Api.config('GET', Api.headers);
      let {filter} = params;
      let addString = '';
      if(filter && filter.tags && filter.tags.length) {
         addString +='&tags='
         filter.tags.forEach(element => {
            addString += element + ','
         });
         addString = addString.substring(0, addString.length - 1);
         delete params.filter.tags;
      }
      conf.url = PathCreator.GetAllItems(path, params) + addString;
      return axios(conf);
   }

   static GetMetadata(path: string, params: any) {
      const conf = Api.config('GET', Api.headers);
      conf.url = path;
      conf.params = params;
      return axios(conf);
   }

   static GetOne(path: string, params: GetOneParams) {
      const conf = Api.config('GET', Api.headers);
      conf.url = PathCreator.PathWithID(path, params.id);
      return axios(conf);
   }

   static CreateItem(path: string, params: CreateParams) {
      const conf = Api.config('POST', Api.headers);
      conf.url = path;
      conf.data = JSON.stringify(params.data);

      return axios(conf);
   }

   static CreateItemByName(path: string, name: string) {
      const conf = Api.config('POST', Api.headers);
      conf.url = path;
      conf.data = JSON.stringify({name: name});

      return axios(conf);
   }

   static GetHashTags(params: GetListParams) {
      const conf = Api.config('GET', Api.headers);
      conf.url = PathCreator.GetAllItems(PathCreator.HASHTAGS_PATH, params);
      return axios(conf);
   }

   static CreateHashTag(name: string) {
      const conf = Api.config('POST', Api.headers);
      conf.url = PathCreator.HASHTAGS_PATH;
      conf.data = JSON.stringify({name: name});
      return axios(conf);
   }

   static DeleteOne(path: string, params: DeleteParams) {
      const conf = Api.config('POST', Api.headers);

      conf.url = PathCreator.DeleteItem(path, params);
      conf.data = {_method: 'DELETE'};
      return axios(conf);
   }

   static DeleteUser(path: string, params: DeleteParams) {
      const conf = Api.config('DELETE', Api.headers);
      conf.url = PathCreator.DeleteItem(path, params);
      // conf.data = {_method: 'DELETE'};
      return axios(conf);
   }

   static DeleteMany(path: string, params: DeleteManyParams) {
      const conf = Api.config('POST', Api.headers);
      conf.url = path;
      conf.data = JSON.stringify({ids: params.ids});
      return axios(conf);
   }

   static UpdateItem(path: string, params: UpdateParams) {
      const conf = Api.config('POST', Api.headers);

      if(!params.data.country_id && params.data.country_id !== '') {
         delete params.data.country_id;
         delete params.data.area_id;
      }
      if(!params.data.city_id && params.data.city_id !== '') {
         delete params.data.area_id;
      }
      if(!params.data.area_id && params.data.area_id !== '') {
         delete params.data.area_id;
      }

      conf.url = PathCreator.PathWithID(path, params.id);
      conf.data = JSON.stringify(params.data);
      return axios(conf);
   }
   static UpdateSnapshots(path: string, params: UpdateParams) {
      const conf = Api.config('PUT', Api.headers);
      conf.url = PathCreator.PathWithID(path, params.id);
      conf.data = JSON.stringify(params.data);
      return axios(conf);
   }


   static updateStylePostState(path: string, params: UpdateParams) {
      const conf = Api.config('POST', Api.headers);
      conf.url = PathCreator.PathWithIdAndRest(path, 'set_posts_state')
      let paramFix = {
         state: params.data.state,
         postIds: [Number.parseInt(params.data.id)]
      }
      conf.data = JSON.stringify(paramFix);
      return axios(conf);
   }

   static GetOneSalon(path: string, params: GetOneParams) {
      const conf = Api.config('GET', Api.headers);
      conf.url = PathCreator.PathWithIdAndRest(path, params.id, 'salon');
      return axios(conf);
   }

   static UpdateSalon(path: string, params: UpdateParams) {
      const conf = Api.config('POST', Api.headers);
      conf.url = PathCreator.PathWithIdAndRest(path, params.id, 'salon');
      conf.data = JSON.stringify(params.data);
      return axios(conf);
   }

   static UpdatePost(path: string, params: UpdateParams) {
      const conf = Api.config('POST', Api.headers);
      conf.url = PathCreator.PathWithID(path, params.id);
      // delete params.data.related_user_id;
      let paramFix = {
         tags: params.data.tags.map(item => item.name),
         state: params.data.state,
         images: params.data.images,
         desc: params.data.description,
         // postIds: [Number.parseInt(params.data.id)]
      };
      conf.data = JSON.stringify(paramFix);
      return axios(conf);
   }

   static UpdateStylistPost(path: string, params: UpdateParams) {
      const conf = Api.config('POST', Api.headers);
      conf.url = PathCreator.PathWithIdAndRest(path, params.data.related_user_id,);
      delete params.data.related_user_id;
      let paramFix = {
         images: params.data.images.map(item => item.image),
         desc: params.data.desc,
         postIds: [Number.parseInt(params.data.id)]
      };

      conf.data = JSON.stringify(paramFix);
      return axios(conf);
   }


   static GetListStylePosts(path: string, params: any) {
      const conf = Api.config('GET', Api.headers);
      const preUrl = PathCreator.PathWithIdAndRest(path, params.id, 'posts');
      conf.url = PathCreator.GetAllItems(preUrl, params);
      return axios(conf);
   }

   static GetReferenceList(path: string, params: any) {
      const conf = Api.config('GET', Api.headers);
      const preUrl = path + params.id;
      conf.url = PathCreator.GetAllItems(preUrl, params);
      return axios(conf);
   }

   static GetManyUsers(path: string, params: any) {
      const conf = Api.config('POST', Api.headers);
      conf.url = path;
      conf.data = JSON.stringify(params);
      return axios(conf);
   }
   static GetManyStylePosts(path: string, params: any) {
      const conf = Api.config('POST', Api.headers);
      conf.url = path;
      conf.data = JSON.stringify(params);
      return axios(conf);
   }
   static GetServicesByCategory(path: string, params: any) {
      const conf = Api.config('GET', Api.headers);
      conf.url = path + '/' + params.id;
      conf.data = JSON.stringify(params);
      return axios(conf);
   }
   static GetCitiesByCountry(path: string, params: any) {
      const conf = Api.config('GET', Api.headers);
      conf.url = path + '/' + params.id;
      conf.data = JSON.stringify(params);
      return axios(conf);
   }
   static GetAreasByCity(path: string, params: any) {
      const conf = Api.config('GET', Api.headers);
      conf.url = path + '/' + params.id;
      conf.data = JSON.stringify(params);
      return axios(conf);
   }
   //    static getManyItem(path: string, params: GetManyParams) {
   //       const conf = Api.config('POST');
   //       conf.url = PathCreator.PathWithID(path, params.ids);
   //       conf.data = JSON.stringify(params.data);
   //       return axios(conf);
   //    }

   static GetAPIVersion(){
      const conf = Api.config('GET', Api.headers_login);
      conf.url = PathCreator.VERSION_PATH;
      return axios(conf);
   }

   static CreateNotification(path: string, params: any) {
      const conf = Api.config('POST', Api.headers)
      conf.url = PathCreator.NOTIFICATION_PATH;
      conf.data = JSON.stringify(params.data)
      return axios(conf)
   }

   static async GetUploadImageURL(path) {
      const confGetWebsiteURLImage= Api.config('GET', Api.headers);
      confGetWebsiteURLImage.url = path;
      const campaignWebsiteURLResponse = await axios(confGetWebsiteURLImage);
      return campaignWebsiteURLResponse.data.url;
   }

   static async UploadImage(url, blobUrl) {
      const confUploadImage = Api.config('PUT', {});
      confUploadImage.headers = {
         'x-ms-blob-type': 'BlockBlob',
         'Content-Type': 'application/octet-stream',
      };
      confUploadImage.url = url
      confUploadImage.data = blobUrl
      return axios(confUploadImage);
   }

   static async UpdateCampaign(path: string, params: UpdateParams) {
      let website_banner = params.data.website_banner.src;
      let app_banner = params.data.app_banner.src;
      if(params.data.website_banner.rawFile) {
         const extension = getExtensionFile(params.data.website_banner.rawFile.name)
         const urlWebsiteImage = await this.GetUploadImageURL(path + `/upload?extension=${extension}`);
         await this.UploadImage(urlWebsiteImage, params.data.website_banner.rawFile);
         website_banner = getPathFromUrl(urlWebsiteImage);
      }
      if(params.data.app_banner.rawFile) {
         const extension = getExtensionFile(params.data.app_banner.rawFile.name)
         const urlBannerImage = await this.GetUploadImageURL(path + `/upload?extension=${extension}`);
         await this.UploadImage(urlBannerImage, params.data.app_banner.rawFile);
         app_banner = getPathFromUrl(urlBannerImage);
      }
      console.log(website_banner);
      console.log(app_banner);
      const conf = Api.config('PUT', Api.headers);
      conf.url = PathCreator.PathWithID(path, params.id);
      conf.data = JSON.stringify({
         ...params.data,
         website_banner,
         app_banner,
      });
      return axios(conf);
   }

   static async UpdateCountry(path: string, params: UpdateParams) {
      let flag = params.data.flag.src;

      if(params.data.flag.rawFile) {
         const extension = getExtensionFile(params.data.flag.rawFile.name)
         const urlFlagImage = await this.GetUploadImageURL(path + `/upload?extension=${extension}`);
         await this.UploadImage(urlFlagImage, params.data.flag.rawFile);
         flag = getPathFromUrl(urlFlagImage);
      }

      const conf = Api.config('PUT', Api.headers);
      conf.url = PathCreator.PathWithID(path, params.id);
      conf.data = JSON.stringify({
         ...params.data,
         flag,
      });
      return axios(conf);
   }
   
   static async UpdateAdminVersion(path: string, params: UpdateParams) {
      const conf = Api.config('PUT', Api.headers);
      conf.url = path;
      conf.params = {
         key: "app.soft.update",
         value: params.data.version,
      }
      return axios(conf);
   }

   static UpdateNotifications(path: string, params: UpdateParams) {
      const conf = Api.config('POST', Api.headers);
      conf.url = PathCreator.PathWithIdAndRest(path, params.id);
      conf.data = JSON.stringify(params.data);
      return axios(conf);
   }
}
